/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcSystemListResponse } from '../../models/bc-system-list-response';

export interface GetAllSystems$Params {
}

export function getAllSystems(http: HttpClient, rootUrl: string, params?: GetAllSystems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllSystems.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcSystemListResponse>>;
    })
  );
}

getAllSystems.PATH = '/business-central/systems/all';
